import * as React from 'react';
import { find, flow, forEach, get, head, isEmpty } from 'lodash';
import { InjectedFormProps } from 'redux-form';
import { connect } from 'react-redux';
import { IStore } from '../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { actions as brandingActions } from '../../../../services/branding/reducer';
import RenewalForm from './renewal';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';
import { IAuthState } from '../../../../services/auth/models';
import { IBrandingActions, IBrandingState } from '../../../../services/branding/models';
import Heap from '../../../../helpers/Heap';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { paymentMethodActions } from '../../../../services/paymentMethod/actions';
import { IPaymentMethodActions } from '../../../../services/paymentMethod/models';
import { Spinner } from '../Components/Spinner';
import { push } from 'react-router-redux';
import { Promise } from 'es6-promise';

export interface IRenewalEditProps extends InjectedFormProps {
  auth: IAuthState;
  branding: IBrandingState;
  history: any;
  quote: IQuoteState;
  dispatch: any;
  match: any;
  actions: {
    auth: IAuthActions;
    push: (route: string) => void;
    calculate: any;
    branding: IBrandingActions,
    quote: IQuoteActions;
    destroy(formName: string);
    reset(formName: string);
    paymentMethod: IPaymentMethodActions;
    change: (form, field, value) => void;
  };
}

class RenewalEdit extends React.Component<IRenewalEditProps, any> {

  constructor(props) {
    super(props);
    // const { quote } = props;
    this.state = {
      loading: true,
    }

    this.initRenewal();
    this.initTracking();
  }


  private initRenewal = () => {
    const { auth, actions, match: { params } } = this.props;

    let selectedQuote = null;
    forEach(auth.customer.renewals, (quoteSelected) => {
      if (params.id === quoteSelected.id) {
        selectedQuote = quoteSelected;
      }
    });

    if (!selectedQuote) {
      actions.push('/account/summary');
    }

    if (selectedQuote && !isEmpty(get(head(selectedQuote.premiums), 'referrals', []))) {
      actions.push('/account/summary')
      return;
    }

    if (selectedQuote) {
      Promise.resolve(actions.quote.initRenewal(selectedQuote)).then(() => {
        this.setState({ loading: true })
        Promise.resolve(actions.quote.loadChannels()).then(() => {
          this.loadRenewalChannel(selectedQuote)
        })
      });
    }
  }

  private initTracking = () => {
    const { quote, auth, actions } = this.props;
    const renewingPolicyId = get(quote, 'application.renewingPolicyId');
    const renewingPolicy = find(get(auth, 'customer.activePolicies'), ['id', renewingPolicyId]);

    Heap.trackActivePolicyEvent(
      'RenewalViewPage',
      renewingPolicy,
      get(auth, 'customer.marketingOptions'),
      actions.paymentMethod.getPolicyPaymentMethod(get(renewingPolicy, 'assignedPaymentMethods')),
    );

    Heap.trackEvent('RenewalView', quote.application, 'quote')
  }

  private findChannelKeyFromName = (name: string) => {
    const { quote } = this.props;

    if (quote.channels && quote.channels.length) {
      const channel = quote.channels.filter((channel) => {
        return channel.name === name;
      }).shift();

      if (channel) {
        return channel.key;
      }
    }

    return null;
  }

  private loadRenewalChannel = (selectedQuote) => {
    const { actions, quote } = this.props;
    if (selectedQuote.quoteType === 'renewal') {
      let channel = null;

      if (selectedQuote.channelName && quote.channels && quote.channels.length) {
        channel = this.findChannelKeyFromName(selectedQuote.channelName);
      }

      if (!channel) {
        channel = 'admiral-b2c'
      }

      const pos = channel.search('-renewal');
      if (pos > -1) {
        channel = channel.substr(0, pos);
      }
      channel += '-renewal';

      selectedQuote.channel = { key: channel };

      Promise.resolve(actions.branding.loadChannel(channel)).then(() => {
        this.setState({ loading: false })
      }).catch((error) => {
        console.log(error)
        this.setState({ loading: false })
      });
    }
  }

  public render() {
    const { actions, history, quote, } = this.props;
    const { loading } = this.state;

    const documentsUrl = `/account/renewals/${quote.application.id}/documents`;
    const product = actions.branding.getProduct();

    if (loading) {
      return (
        <Spinner text={'Loading your Renewal...'}/>
      )
    }

    if (!loading) {
      return (
        <RenewalForm
          documentsUrl={documentsUrl}
          history={history}
          product={product}
          reInitRenewal={this.initRenewal}
          {...this.props}
        />
      )
    }
  }
}

export default flow([
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
        quote: state.quote,
        branding: state.branding,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
        paymentMethod: bindActionCreators({ ...paymentMethodActions }, dispatch),
      },
    }),
  ),
])(RenewalEdit);
